import { useMutation, useQueryClient } from '@northladder/services';
import { IApiError } from '@northladder/utilities';

import { CUSTOMER_SERVICE_API } from '../customerServiceClient';
import { ICreateGradeChangeRequestData } from '../types';

import { FETCH_GRADE_REVIEW_REQUEST_QUERY } from './useGradeReviewRequestListQuery';

/**
 * This is to track the create grade change request mutation keys in react query cache.
 */
const MUT_CREATE_GRADE_CHANGE_REQUEST_KEY =
  'create-grade-change-request-mutation-key';

interface ICreateGradeChangeRequest {
  onError?: (err: IApiError) => void;
  /**
   * Callback to be called when the change grade request successfully created
   */
  onSuccessCallback?: (
    createGradeChangeResponse: ICreateGradeChangeRequestData
  ) => void;
}

/**
 * This performs create grade change request mutation.
 */
export const useCreateGradeChangeRequestMutation = (
  options?: ICreateGradeChangeRequest
) => {
  const { onSuccessCallback, onError } = options || {};

  const queryClient = useQueryClient();
  const { isPending, isError, error, mutate } = useMutation({
    mutationKey: [MUT_CREATE_GRADE_CHANGE_REQUEST_KEY],
    networkMode: 'always', // Even make calls when offline
    mutationFn: CUSTOMER_SERVICE_API.createGradeChangeRequest,
    onSuccess: (response) => {
      onSuccessCallback?.(response);
      queryClient.invalidateQueries({
        queryKey: [FETCH_GRADE_REVIEW_REQUEST_QUERY],
      });
    },
    onError,
  });

  return {
    error,
    isError,
    isSubmitting: isPending,
    mutate,
  };
};
